"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
let MainLayout = class extends Vue {
  constructor() {
    super(...arguments);
    //提示信息弹窗
    // @Ref("noticeDialog")
    // public _notice_dialog!: NoticeDialog;
    this.isWeiXin = false;
  }
  mounted() {
    return __async(this, null, function* () {
      this.isInWechatMP();
    });
  }
  isInWechatMP() {
    if (navigator.userAgent.match(/miniprogram/i) || window.__wxjs !== void 0 && window.__wxjs.environment === "miniprogram" || window.navigator.userAgent.match(/Mobile/i)) {
      this.isWeiXin = true;
    } else {
      this.isWeiXin = false;
    }
  }
  // openNotice(){
  //   this._notice_dialog.open();
  // }
};
MainLayout = __decorateClass([
  Component({
    components: {
      // NoticeDialog
    }
  })
], MainLayout);
export {
  MainLayout as default
};
